import { gql } from "@apollo/client";
import { Exhibition as exhibition } from "../fragments";
import SEARCH_SYNOPSIS_TERMS from "../fragments/SearchSynopsisTerms";

const FETCH_EXHIBITION = props => gql`
  query FetchExhibition($id: Int) {
    exhibition(id: $id) {
      ${exhibition(props)}
    }
  }
`;

const FETCH_EXHIBITIONS = props => gql`
  query FetchExhibitions($input: ExhibitionFilterInput) {
    exhibitions(input: $input) {
      count
      edges {
        ${exhibition(props)}
      }
    }
  }
`;

const FETCH_EXHIBITIONS_V2 = props => gql`
  query FetchExhibitionsV2($input: AdvExhibitionFilterInput!) {
    exhibitionsV2(input: $input) {
      count
      edges {
        ${exhibition(props)}
      }
      sqlQuery
    }
  }
`;

const EXHIBITION_LIST_FIELDS = `
  count
  edges {
    id
    contact {
      company
      name
    }
    endDay
    endMonth
    endYear
    startDay
    startMonth
    startYear
    title
  }
`;

const FETCH_EXHIBITIONS_LIST = gql`
  query FetchExhibitionsV2($input: AdvExhibitionFilterInput!) {
    exhibitionsV2(input: $input) {
      ${EXHIBITION_LIST_FIELDS}
    }
  }
`;

// The results page also shows the search as removable tags.
const FETCH_EXHIBITIONS_SEARCH_RESULTS = gql`
  query FetchExhibitionsSearchResults($input: AdvExhibitionFilterInput!) {
    exhibitionsV2(input: $input) {
      ${EXHIBITION_LIST_FIELDS}
      ${SEARCH_SYNOPSIS_TERMS}
    }
  }
`;

export {
  FETCH_EXHIBITION,
  FETCH_EXHIBITIONS,
  FETCH_EXHIBITIONS_V2,
  FETCH_EXHIBITIONS_LIST,
  FETCH_EXHIBITIONS_SEARCH_RESULTS,
};
